import React from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';
import { useTheme } from 'styled-components';
import { IDefaultTheme } from '@source/styles/themes';

type BoxTemplateProps = {
  children: React.ReactNode;
  padding?: string;
  mt?: string;
  mb?: string;
  style?: React.CSSProperties | SxProps<Theme>;
  error?: boolean;
};

const BoxTemplate: React.FC<BoxTemplateProps> = ({
  children,
  padding,
  mt,
  mb,
  error,
  style
}): JSX.Element => {
  const theme = useTheme() as IDefaultTheme;

  return (
    <Box
      sx={{
        background: theme.colors.white,
        marginTop: mt || '2.4rem',
        marginBottom: mb || 0,
        border: `${
          error
            ? `1px solid ${theme.colors.red}`
            : `1px solid ${theme.colors.grayBorder}`
        }`,
        padding: padding ? padding : '2.4rem 3.2rem',
        borderRadius: { xs: 'none', md: '1.6rem' },
        ...style
      }}
    >
      {children}
    </Box>
  );
};

export default BoxTemplate;
